import React, { FC } from 'react';
import { compact } from 'lodash';
import { Flex, Icon, Text as BaseText, TextProps } from 'roo-ui/components';
import { useHeaderContext } from '../../../HeaderContext';
import { formatNumber } from '../../../../../lib/formatters';
import { QffAuthData } from '../../../types';

export const QffAuthDetails = () => {
  const { qffAuthData } = useHeaderContext();
  return <QffAuthDetailsMemo {...qffAuthData} />;
};

type MemoProps = QffAuthData;

const QffAuthDetailsMemo: FC<MemoProps> = ({
  isAuthenticated,
  title,
  firstName,
  lastName,
  membershipTier,
  pointsBalance,
}) => {
  if (!isAuthenticated) return null;

  return (
    <Flex alignItems="center" data-testid="auth-details-wrapper">
      <Flex
        flexDirection="column"
        color="white"
        justifyContent="flex-start"
        ml={2}
      >
        <Text
          fontSize="header.sm"
          fontWeight="bold"
          data-hj-suppress
          pr={2}
          data-testid="member-name"
        >
          {compact([title, firstName, lastName]).join(' ')}
        </Text>
        <Flex>
          <Text data-testid="member-points-balance">
            {formatNumber(pointsBalance!)} points
          </Text>
          <Text mx={1}>-</Text>
          <Text data-testid="member-tier">{membershipTier}</Text>
        </Flex>
      </Flex>
      <Icon name="expandMore" ml={4} />
    </Flex>
  );
};

const Text: FC<TextProps> = (props) => (
  <BaseText fontSize="header.sm" fontWeight="bold" {...props} />
);
